<div class="container">
    <div class="alert alert-danger reducir-alert" role="alert" *ngIf="formularioValido">
         <b> El botón se activara cuando complete toda la información. </b>
    </div>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div class="row centrar-botones-form" *ngIf="!loading">
        <div class="d-grid gap-2 d-md-flex">
        <!-- <div class="col"> -->
            <button *ngIf="botonRegresar" class="btn btn-outline-danger btn-block" (click)="regresar()">
                <i class="fas fa-arrow-left"></i>
                {{DATA_BTNS.regresar}}</button>
        <!-- </div> -->

        <!-- <div class="col" *ngIf="mostrarBotonVerde"> -->
            <button *ngIf="mostrarBotonVerde" class="btn btn-success btn-block" (click)="guardar()" [disabled]="formularioValido">
                <i class="far fa-save"></i>
                {{textBoton}}</button>
        </div>
    </div>
</div>
